/**
 * Route for `igaming-player-ltv-per-affiliate-advanced`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingPlayerLtvPerAffiliateAdvancedPage } from "../features/igaming-player-ltv-per-affiliate-advanced/IgamingPlayerLtvPerAffiliateAdvancedPage";

export const igamingPlayerLtvPerAffiliateAdvancedRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-player-ltv-per-affiliate-advanced",
	component: IgamingPlayerLtvPerAffiliateAdvancedPage,
});

export default igamingPlayerLtvPerAffiliateAdvancedRoute;
